import { render, staticRenderFns } from "./achievementsdel.vue?vue&type=template&id=6d835714&scoped=true&"
import script from "./achievementsdel.vue?vue&type=script&lang=js&"
export * from "./achievementsdel.vue?vue&type=script&lang=js&"
import style0 from "./achievementsdel.vue?vue&type=style&index=0&id=6d835714&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d835714",
  null
  
)

export default component.exports